<template>
  <footer>
    <div class="container mx-auto relative px-2 xl:px-0 mt-12 md:mt-24">
      <p class="text-grey text-xl text-center uppercase">
        <span class="border-b-2 px-20 pb-2">{{ $t("footer.park") }}</span>
      </p>
      <div
        class="flex justify-around md:justify-center items-center flex-wrap py-2 px-4 md:px-0"
      >
        <!-- {{logos.parks.items}} -->
        <div
          class="md:w-auto px-2 lg:px-4 xl:px-8 py-2 w-6/12"
          v-for="(item, idx) in logos.parks.items"
          :key="idx"
        >
          <a :href="item.href" class="flex">
            <img
              :src="item.src"
              :alt="item.alt"
              :title="item.alt"
              class="md:w-full mx-auto w-7/12 parks opacityGrey"
            />
          </a>
        </div>
      </div>
      <div class="flex justify-center items-start flex-col md:flex-row">
        <div class="flex-1">
          <p class="mt-6 text-grey text-xl text-center uppercase">
            <span class="border-b-2 px-20 pb-2">{{ $t("footer.tour") }}</span>
          </p>
          <div
            class="flex justify-around md:justify-center items-center flex-wrap py-2 px-4 md:px-0"
          >
            <div
              class="w-6/12 md:w-auto px-4 xl:px-8 py-2"
              v-for="(item, idx) in logos.tours.items"
              :key="idx"
            >
              <a :href="item.href" class="flex">
                <img
                  :src="item.src"
                  :alt="item.alt"
                  :title="item.alt"
                  class="w-8/12 md:w-full mx-auto"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <p class="mt-6 text-grey text-xl text-center uppercase">
            <span class="border-b-2 px-20 pb-2">{{
              $t("footer.xailing")
            }}</span>
          </p>
          <div
            class="flex flex-col justify-around md:justify-center items-center flex-wrap py-2 px-4 md:px-0"
          >
            <div
              class="w-6/12 md:w-auto px-4 xl:px-8 py-2"
              v-for="(item, idx) in logos.navy.items"
              :key="idx"
            >
              <a class="flex" :href="item.href">
                <img
                  :src="item.src"
                  :alt="item.alt"
                  :title="item.alt"
                  class="w-8/12 md:w-1/2 mx-auto min-w-36 opacityGrey"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <p class="mt-6 text-grey text-xl text-center uppercase">
        <span class="border-b-2 px-20 pb-2">{{ $t("footer.hotel") }}</span>
      </p>
      <div class="flex justify-center items-center my-12 px-4 md:px-0">
        <center>
          <a class="md:w-1/5 w-3/4" href="https://www.hotelxcaret.com/es/">
            <img
              src="https://photo-public.s3.amazonaws.com/suf/footer/hoteles-g.svg"
              alt="Hotels Xcaret"
              class="w-full parks opacityGrey"
            />
          </a>
        </center>
      </div>
      <div
        class="flex justify-center md:justify-center items-center flex-wrap py-2 px-4 md:px-0"
      >
        <div
          class="w-1/3 md:w-auto px-8 py-2"
          v-for="(item, idx) in logos.hotels.items"
          :key="idx"
        >
          <a class="flex" :href="item.href">
            <img
              :src="item.src"
              :alt="item.alt"
              :title="item.alt"
              class="w-full hotels opacityGrey"
            />
          </a>
        </div>
      </div>
      <div class="flex justify-center items-center my-12 px-4 md:px-0">
        <a
          class="md:w-1/5 w-3/4"
          href="https://www.grupoexperienciasxcaret.com/"
          ><img
            src="https://photo-public.s3.amazonaws.com/suf/footer/gpo-xcaret-g.svg"
            alt="Grupo Xcaret"
            class="w-full"
        /></a>
      </div>
    </div>
    <div class="mx-auto relative px-0">
      <div class="w-full flex justify-center items-end">
        <button
          class="tabs-footer w-1/2 md:w-auto md:mx-2 rounded-t-lg py-2 px-4"
          :class="tabActive == 1 && 'active'"
          @click="tabActive = 1"
          type="button"
        >
          <span class="mx-4">{{ $t("footer.contact") }}</span>
        </button>
        <button
          class="tabs-footer w-1/2 md:w-auto md:mx-2 rounded-t-lg py-2 px-4"
          :class="tabActive == 2 && 'active'"
          @click="tabActive = 2"
          type="button"
        >
          <span class="mx-4">{{ $t("footer.discover") }}</span>
        </button>
      </div>
      <div
        class="tabs-content px-4 py-8 bg-black text-white"
        :class="tabActive == 1 && 'active'"
      >
        <div
          class="container flex flex-col justify-center items-center px-0 mx-auto"
        >
          <div>
            <p class="px-3 lg:px-0 py-2 text-center font-semibold">
              {{ $t("footer.header") }}
            </p>
            <p class="my-2 p-3 lg:p-0 text-center">
              <span v-html="$t('footer.schedule')"></span>
              <br />
              <span v-html="$t('footer.schedule_wknd')"></span>
              <br /><br />
              {{ $t("footer.info") }}
            </p>
          </div>
          <div class="lg:w-1/4 pr-0 lg:p-2 text-center">
            <p class="font-semibold py-2">{{ $t("footer.social") }}</p>
            <div class="flex justify-around items-center social-media">
              <a
                class="px-3 py-1"
                title="facebook-f"
                href="https://www.facebook.com/XcaretPark"
                ><svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="facebook-f"
                  class="svg-inline--fa fa-facebook-f fa-w-10 fa-2x"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                  ></path></svg></a
              ><a
                class="px-3 py-1"
                title="twitter"
                href="https://twitter.com/XcaretPark"
                ><svg
                  class="svg-inline--fa fa-twitter fa-2x"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="twitter"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M459.4 151.7c.325 4.548 .325 9.097 .325 13.65 0 138.7-105.6 298.6-298.6 298.6-59.45 0-114.7-17.22-161.1-47.11 8.447 .974 16.57 1.299 25.34 1.299 49.06 0 94.21-16.57 130.3-44.83-46.13-.975-84.79-31.19-98.11-72.77 6.498 .974 12.99 1.624 19.82 1.624 9.421 0 18.84-1.3 27.61-3.573-48.08-9.747-84.14-51.98-84.14-102.1v-1.299c13.97 7.797 30.21 12.67 47.43 13.32-28.26-18.84-46.78-51.01-46.78-87.39 0-19.49 5.197-37.36 14.29-52.95 51.65 63.67 129.3 105.3 216.4 109.8-1.624-7.797-2.599-15.92-2.599-24.04 0-57.83 46.78-104.9 104.9-104.9 30.21 0 57.5 12.67 76.67 33.14 23.72-4.548 46.46-13.32 66.6-25.34-7.798 24.37-24.37 44.83-46.13 57.83 21.12-2.273 41.58-8.122 60.43-16.24-14.29 20.79-32.16 39.31-52.63 54.25z"
                  ></path></svg></a
              ><a
                class="px-3 py-1"
                title="instagram"
                href="https://www.instagram.com/xcaretpark/"
                ><svg
                  class="svg-inline--fa fa-instagram fa-2x"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="instagram"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                  ></path></svg></a
              ><a
                class="px-3 py-1"
                title="youtube"
                href="https://www.youtube.com/user/XcaretPark"
                ><svg
                  class="svg-inline--fa fa-youtube fa-2x"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="youtube"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    class=""
                    fill="currentColor"
                    d="M549.7 124.1c-6.281-23.65-24.79-42.28-48.28-48.6C458.8 64 288 64 288 64S117.2 64 74.63 75.49c-23.5 6.322-42 24.95-48.28 48.6-11.41 42.87-11.41 132.3-11.41 132.3s0 89.44 11.41 132.3c6.281 23.65 24.79 41.5 48.28 47.82C117.2 448 288 448 288 448s170.8 0 213.4-11.49c23.5-6.321 42-24.17 48.28-47.82 11.41-42.87 11.41-132.3 11.41-132.3s0-89.44-11.41-132.3zm-317.5 213.5V175.2l142.7 81.21-142.7 81.2z"
                  ></path></svg></a>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tabs-content px-4 py-8 bg-black text-white"
        :class="tabActive == 2 && 'active'"
      >
        <div class="container flex md:flex-row flex-col mx-auto flex-wrap">
          <div class="lg:flex-1 lg:w-auto w-1/2 p-2">
            <p class="pb-6 font-semibold border-b border-white">
              {{ $t("footer.dst.title") }}
            </p>
            <ul class="pt-4">
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.xcaret.com/es/tours-en-cancun-y-riviera-maya/"
                  >{{ $t("footer.dst.vac") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaret.com/es/que-hacer-en-cancun/">{{
                  $t("footer.dst.cun")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.xcaret.com/es/que-hacer-en-isla-mujeres/"
                  >{{ $t("footer.dst.im") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.xcaret.com/es/que-hacer-en-playa-del-carmen/"
                  >{{ $t("footer.dst.pc") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.xcaret.com/es/que-hacer-en-riviera-maya/"
                  >{{ $t("footer.dst.rm") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaret.com/es/que-hacer-en-cozumel/">{{
                  $t("footer.dst.cz")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaret.com/es/que-hacer-en-tulum/">{{
                  $t("footer.dst.tl")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaret.com/es/conoce-quintana-roo/">{{
                  $t("footer.dst.qr")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaret.com/es/que-hacer-en-mexico/">{{
                  $t("footer.dst.mx")
                }}</a>
              </li>
            </ul>
          </div>
          <div class="lg:flex-1 lg:w-auto w-1/2 p-2">
            <p class="pb-6 font-semibold border-b border-white">
              {{ $t("footer.parks.title") }}
            </p>
            <ul class="pt-4">
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/acerca-de-xcaret/">{{ $t("footer.parks.xc") }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xelha/">{{
                  $t("footer.parks.xh")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xplor/">{{
                  $t("footer.parks.xp")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xplor-fuego/">{{
                  $t("footer.parks.xf")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xavage/">{{
                  $t("footer.parks.xv")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xoximilco/">{{
                  $t("footer.parks.xm")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xenses/">{{
                  $t("footer.parks.xs")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xenotes/">{{
                  $t("footer.parks.xn")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/acerca-de-xichen/">{{
                  $t("footer.parks.xi")
                }}</a>
              </li>
            </ul>
          </div>
          <div class="lg:flex-1 lg:w-auto w-1/2 p-2">
            <p class="pb-6 font-semibold border-b border-white">
              {{ $t("footer.buy.title") }}
            </p>
            <ul class="pt-4">
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/comprar-mi-entrada/">{{ $t("footer.buy.xc") }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/comprar-mi-entrada-xel-ha/">{{
                  $t("footer.buy.xh")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/entrada-xplor/">{{
                  $t("footer.buy.xp")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/entrada-xplor-fuego/">{{
                  $t("footer.buy.xf")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/entrada-xavage/">{{
                  $t("footer.buy.xv")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/entrada-xoximilco/">{{
                  $t("footer.buy.xm")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/entrada-xenses/">{{
                  $t("footer.buy.xs")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/tour-xenotes/">{{
                  $t("footer.buy.xn")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/parques-y-tours/tour-xichen-deluxe/">{{
                  $t("footer.buy.xi")
                }}</a>
              </li>
            </ul>
          </div>
          <div class="lg:flex-1 lg:w-auto w-1/2 p-2">
            <p class="pb-6 font-semibold border-b border-white">
              {{ $t("footer.about.title") }}
            </p>
            <ul class="pt-4">
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/mapa-de-sitio/">{{ $t("footer.about.map") }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://blog.xcaret.com/es/">{{
                  $t("footer.about.blog")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/como-llegar-a-xcaret/">{{
                  $t("footer.about.arrive")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/atracciones-xcaret/">{{
                  $t("footer.about.attractions")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.soyxcaret.com/">{{
                  $t("footer.about.member")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/promociones/">{{ $t("footer.about.promo") }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.tuexperiencia.travel/ya-visite/xcaret.php"
                  >{{ $t("footer.about.visited") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.tuexperiencia.travel/proximo-a-visitar/xcaret.php"
                  >{{ $t("footer.about.visit") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.grupoxcaret.com/es/sostenibilidad-corporativa/"
                  >{{ $t("footer.about.responsib") }}</a
                >
              </li>
            </ul>
          </div>
          <div class="lg:flex-1 lg:w-auto w-1/2 p-2">
            <p class="pb-6 font-semibold border-b border-white">
              {{ $t("footer.other.title") }}
            </p>
            <ul class="pt-4">
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.grupoxcaret.com/es/acerca-de-grupo-xcaret/"
                  >{{ $t("footer.other.about_gx") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.xcaretexperiencias.com/contacto-xcaretexperiencias.php"
                  >{{ $t("footer.other.contact") }}</a
                >
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="/es/modulos-xcaret/">{{
                  $t("footer.other.modules")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaretexperiencias.com/afiliados.php">{{
                  $t("footer.other.affiliates")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.aolxcaret.com/">{{
                  $t("footer.other.agencies")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.bodasxcaret.com/">{{
                  $t("footer.other.weddings")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a href="https://www.xcaretgrupos.com/">{{
                  $t("footer.other.events")
                }}</a>
              </li>
              <li
                class="block py-2 text-sm text-decoration-none text-white hover:text-pastel-green hover:underline"
              >
                <a
                  href="https://www.grupoxcaret.com/es/seccion/sala-de-prensa/"
                  >{{ $t("footer.other.press") }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="relative flex justify-between items-center mx-auto bg-black text-white pb-24 lg:pb-0"
    >
      <div
        class="container px-4 md:px-0 flex flex-col-reverse lg:flex-row justify-between items-center mx-auto border-t"
      >
        <div class="py-4 text-white flex flex-col sm:flex-row text-center">
          <div class="mx-1 sm:mx-4 my-auto w-48 logoXcFooter">
            <img
              alt="Xcaret Park"
              src="https://photo-public.s3.amazonaws.com/suf/logo-xcaret-w.svg"
              class="w-full"
            />
          </div>
          <div>
            <div class="text-xs md:text-sm pb-2">
              <a
                class="underline pr-2 md:pr-4"
                target="_blank"
                href="https://www.xcaret.com/es/terminos-de-uso"
                >{{ $t("footer.gx.terms") }}</a
              >
              <!-- <a
                                class="underline pr-2 md:pr-4"
                                href="/es/mapa-de-sitio/"
                                >{{ $t('footer.gx.map') }}</a
                            > -->
              <a
                class="underline pr-2 md:pr-4"
                target="_blank"
                href="https://www.xcaret.com/es/aviso-de-privacidad/"
                >{{ $t("footer.gx.priv") }}</a
              >
            </div>
            <p
              class="my-1 text-xs"
              itemprop="address"
              itemtype="http://schema.org/PostalAddress"
            >
              <span itemprop="streetAddress">{{ $t("footer.gx.address") }}</span
              >,
              <span itemprop="addressLocality">{{ $t("footer.gx.loc") }}</span
              >, <span itemprop="telephone">{{ $t("footer.gx.phone") }}</span
              >,
              <span itemprop="addressRegion">{{ $t("footer.gx.region") }}</span
              >.
              <span itemprop="addressCountry">{{
                $t("footer.gx.country")
              }}</span
              >. <span itemprop="postalCode">{{ $t("footer.gx.pc") }}</span
              >.
            </p>
            <p class="my-1 text-xs" itemtype="http://schema.org/Park">
              <span>{{ $t("footer.gx.phone_cun") }}</span
              ><span itemprop="url"
                ><a href="https://www.xcaret.com/">{{
                  $t("footer.gx.web")
                }}</a></span
              ><span
                itemprop="openingHours"
                content="Lu,Ma,Mi,Ju,Vi,Sa 08:30-19:00"
                >{{ $t("footer.gx.schedule") }}</span
              >
            </p>
            <p class="my-1 text-xs">
              {{ $t("footer.gx.copyr") }}
            </p>
          </div>
        </div>
        <div class="w-full lg:w-3/4 lg:ml-4 px-4 lg:px-0 py-4">
          <img
            alt="Reconocimiento Xcaret"
            src="https://photo-public.s3.amazonaws.com/suf/footer/reconocimientos_es.svg"
            class="w-full"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { ref } from "vue";

import Tab from "./TabContain.vue";

export default {
  data() {
    return {
      tabActive: 1,
      logos: {
        parks: {
          title: "Parques",

          items: [
            {
              href: "https://www.xcaret.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xcaret-g.svg",

              alt: "Parque Xcaret",
            },

            {
              href: "https://es.xelha.com/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xelha-g.svg",

              alt: "Parque Xel-Há",
            },

            {
              href: "https://www.xplor.travel/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xplor-g.svg",

              alt: "Parque Xplor",
            },

            {
              href: "https://www.xplor.travel/es/entrada-xplor-fuego/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xplorfuego-g.svg",

              alt: "Parque Xplor Fuego",
            },

            {
              href: "https://www.xavage.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xavage-g.svg",

              alt: "Xavage Park",
            },

            {
              href: "https://www.xoximilco.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xoxi-g.svg",

              alt: "Xoximilco",
            },

            {
              href: "https://www.xensespark.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xenses-g.svg",

              alt: "Xenses",
            },

            {
              href: "https://www.xibalba.travel/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xibalba-g.svg",

              alt: "Xibalba",
            },
          ],
        },

        tours: {
          title: "Tours",

          items: [
            {
              href: "https://www.xenotes.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xenotes-g.svg",

              alt: "Tour Xenotes",
            },

            {
              href: "https://www.xcaretexpeditions.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/exp2-v-g.svg",

              alt: "Xcaret Expeditions",
            },

            {
              href: "https://www.xichen.com.mx/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xichen-g.svg",

              alt: "Tour Xichén",
            },

            {
              href: "https://www.cobatour.travel/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/coba-g.svg",

              alt: "Tour Coba",
            },

            {
              href: "https://www.tulumtour.travel/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/tulum-g.svg",

              alt: "Tour Tulum",
            },
          ],
        },

        navy: {
          title: "Xcaret Xailing",

          items: [
            {
              href: "https://www.xailing.com/es/ferry-isla-mujeres/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/xailing-g.svg",

              alt: "Ferry Xailing",
            },

            {
              href: "https://www.xailing.com/es/tour-catamaran-round-trip/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/catamaran.svg",

              alt: "Catamarán Xailing",
            },
          ],
        },

        hotels: {
          title: "Hoteles",

          items: [
            {
              href: "https://www.hotelxcaretmexico.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/hxm-v-g.png",

              alt: "Hotel Xcaret México",
            },

            {
              href: "https://www.lacasadelaplaya.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/casa-g.png",

              alt: "La Casa de la Playa",
            },

            {
              href: "https://www.hotelxcaretarte.com/es/",

              src: "https://photo-public.s3.amazonaws.com/suf/footer/hxa-g.svg",

              alt: "Hotel Xcaret Arte",
            },
          ],
        },
        concentradorH: {
          href: "https://www.hotelxcaret.com/es/",

          src: "https://photo-public.s3.amazonaws.com/suf/footer/hoteles-g.svg",

          alt: "Hotels Xcaret",
        },
        group: {
          href: "https://www.grupoexperienciasxcaret.com/",

          src: "https://photo-public.s3.amazonaws.com/suf/footer/gpo-xcaret-g.svg",

          alt: "Grupo Xcaret",
        },
        parksTours: [
          {
            en: {},
            es: {},
          },
        ],
      },
    };
  },
};
</script>
